// extracted by mini-css-extract-plugin
export default {"root":"MerchantContractId_root__jl8fO","labelContainer":"MerchantContractId_labelContainer__5dwgn","copyIcon":"MerchantContractId_copyIcon__1GVi+"};